<template>
  <ErrorDisplay v-if="store.error" :message="store.error.message" :loading="store.loading" @retry="store.fetch" />
  <Loading v-else-if="store.loading" />
  <v-autocomplete
    v-else
    label="Land"
    class="mt-3 mb-2"
    v-model="internalValue"
    item-title="Staat"
    item-value="Kennzeichen"
    :items="store.data"
    :loading="store.loading"
    placeholder="--- Land wählen ---"
    :return-object="false"
  />
</template>

<script lang="ts" setup>
import {useNationalityStore} from '@/store/nationality';
import Loading from '@/components/Loading.vue';
import {computed, watch} from 'vue';
import ErrorDisplay from './ErrorDisplay.vue';
const store = useNationalityStore();
store.fetch().catch(console.error);
const props = defineProps<{
    modelValue?: string | null
    showLabel?: boolean
}>();

const emits = defineEmits({'update:modelValue': (data: string) => typeof data === 'string'});

const internalValue = computed({
  get() {
    return props.modelValue || '';
  },
  set(newVal: string) {
    emits('update:modelValue', newVal);
    return;
  },
});

watch(() => store.data, (newData) => {
  if (newData.length === 0) return;

  internalValue.value = newData[0].Kennzeichen;
});

defineExpose({
  store,
  internalValue,
  fetch,
  props,
  Loading,
  ErrorDisplay,
});
</script>
